import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { EquipoMide, EquipoMideRes } from "../../app/types/genericTables.types";

type UseEquipmentMideType = {
  equipmentMideList: EquipoMide[];
  equipmentMideListFiltered: EquipoMideRes[];
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
  fetchByAnalysisType: (idAnalysisType: number) => Promise<void>;
  clear: () => void;
};

export const useEquipmentMide = create<UseEquipmentMideType>((set, get) => ({
  loading: false,
  equipmentMideList: [],
  equipmentMideListFiltered: [],
  query: "",
  clear: () => set({ equipmentMideList: [], equipmentMideListFiltered: [] }),
  setQuery: (query) => set({ query }),
  fetchAll: async () => {
    set({ loading: true });
    try {
      const endpoint = "/generic/EquipoMide";
      const { data: response } = await getData(endpoint);
      set(() => ({
        equipmentMideList: response,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching analysisTypeList:", error);
      set({ loading: false });
    }
  },
  fetchByAnalysisType: async (idAnalysisType) => {
    set({ loading: true, equipmentMideListFiltered: [] });
    try {
      const endpoint = `/generic/EquipoMide/filtered?tipo_analisis=${idAnalysisType}`;
      const { data: response } = await getData(endpoint);
      set(() => ({
        equipmentMideListFiltered: response.map(
          (item: EquipoMide) => item.equipo
        ),
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching analysisTypeList:", error);
      set({ loading: false });
    }
  },
}));
